import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['vendors'])
export default class Vendors extends Component {

  constructor(props) {
    super(props)

    this.props.vendors.loadAllVendors()
  }

  newVendor(row) {
    this.props.vendors.newVendor(row.name)
  }

  updateVendor(row, cellText, cellValue) {
    this.props.vendors.updateVendor(row.id, cellValue)
  }

  deleteVendor(id) {
    if (confirm('Are you sure you want to delete this Vendor?')) {
      this.props.vendors.deleteVendor(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteVendor(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newVendor.bind(this)
    }

    const vendorTable = (
      <BootstrapTable
          data={ this.props.vendors.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateVendor.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Vendors" content={ vendorTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/vendors.js